module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAALCAYAAACZIGYHAAABJUlEQVQokW3SvyuEcRwH8Nddl0FKBv4BizJYdJcug3oWg3LrJSVKUlYGsWBkIEmyychwDO4sEt0pGZB/wL9gEobn++TxuPfy7fPr3efz/r5z9XpdBrOYQxlf6MU0dnCJG2wlzVEUyWcIyjjCG75DbhQbIW5hE5PpoTTJMG5D00yKZAyPIV7DEs4wngwWwtuPB+xjNbNdES+peBfd4bQSWgUMBIJDLPqPPhxnchvoQLPRaBTzuBILON+GoAdduGtTWwsb3ucxhU6st2ksibV4blNbwCAmC+IvK6OJT7GwCcp49ytyglmxfhNRFNUSYVuI0MCH2BMwhKcMQVVsgypq/P3ia1Sw7ddMI3hN9SzjJJxymiSzZjvHitgDOezhIlWvhC0P0kM/bBFBwS9Cpp0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/59.png
// module id = K0ug
// module chunks = 0